import { loadFromStorage } from "./storage";

export type EngineerFilters = {
  material: string;
  description: string;
  emitter: string;
  centers: string[];
  statuses: string[];
  startDate: string;
  endDate: string;
  classificationQuizStartDate: string;
  classificationQuizFinishDate: string;
  classificationApprovalStartDate: string;
  classificationApprovalEndDate: string;
};

const normalizeString = (value: string): string => value.trim();

export const getEngineerFiltersFromStorage = (): EngineerFilters => ({
  material: normalizeString(loadFromStorage<string>("materialPartNumber", "")),
  description: normalizeString(loadFromStorage<string>("materialPartDesc", "")),
  emitter: normalizeString(loadFromStorage<string>("emitentePartNumber", "")),
  centers: loadFromStorage<{ value: string }[]>("selectedCenter", [])
    .map((item) => normalizeString(item.value))
    .filter(Boolean),
  statuses: loadFromStorage<{ status: string }[]>("selectedStatus", [])
    .map((item) => normalizeString(item.status))
    .filter(Boolean),
  startDate: normalizeString(loadFromStorage<string>("startDate", "")),
  endDate: normalizeString(loadFromStorage<string>("endDate", "")),
  classificationQuizStartDate: normalizeString(
    loadFromStorage<string>("classificationQuizStartDate", ""),
  ),
  classificationQuizFinishDate: normalizeString(
    loadFromStorage<string>("classificationQuizFinishDate", ""),
  ),
  classificationApprovalStartDate: normalizeString(
    loadFromStorage<string>("classificationApprovalStartDate", ""),
  ),
  classificationApprovalEndDate: normalizeString(
    loadFromStorage<string>("classificationApprovalEndDate", ""),
  ),
});

export const hasAnyNonDateEngineerFilter = (filters: EngineerFilters): boolean =>
  !!filters.material ||
  !!filters.description ||
  !!filters.emitter ||
  filters.centers.length > 0 ||
  filters.statuses.length > 0;

export const normalizeEngineerStatusesForReport = (
  statuses: string[],
): string[] => {
  const normalized = new Set<string>();

  statuses.forEach((status) => {
    if (status === "FINALIZADO") {
      normalized.add("FINALIZADO");
      normalized.add("ENTREGUE_SAP");
      return;
    }

    normalized.add(status);
  });

  return Array.from(normalized);
};
